<template>
  <div class="live-detail">
    <column-skeleton
      v-if="loading"
      style="margin-bottom: 100vh"
    ></column-skeleton>
    <div class="live-detail-banner-box">
      <img :src="live.cover_img" class="live-detail-banner" />
      <van-count-down
        :time="time"
        class="live-detail-count-down"
        v-if="time > 0"
      >
        <template #default="timeData">
          <img
            class="time_img"
            src="/static/img/icon_live_count_down.svg"
            alt=""
          />
          <span>距离直播开始：</span>
          <span class="times">{{ timeData.days }}</span>
          <span class="time_unit">天</span>
          <span class="times">{{ timeData.hours }}</span>
          <span class="time_unit">时</span>
          <span class="times">{{ timeData.minutes }}</span>
          <span class="time_unit">分</span>
          <span class="times">{{ timeData.seconds }}</span>
          <span class="time_unit">秒</span>
        </template>
      </van-count-down>
    </div>

    <div class="live-detail-header">
      <div class="header-title">{{ live.title }}</div>
      <div class="header-view">
        <div class="header-time-long">{{ live.start_at_format }}</div>
        <div class="header-view-count">
          <div class="header-view-count-text">
            <!--{{live.appointment_count}}人-->
            已预约
          </div>
          <div class="header-view-count-images">
            <img
              :src="item"
              alt=""
              v-for="(item, index) in live.last_study_user_avatar"
              :key="index"
            />
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div class="live-detail-content">
      <div class="live-detail-content-title">直播介绍</div>
      <div class="live-detail-content-detail">
        <div v-html="live.content"></div>
      </div>
    </div>

    <div class="live-share-box">
      <img
        @click="openShareData"
        src="/static/bytx/detail_share_btn.svg"
        alt=""
      />
      <img @click="toHome" src="/static/bytx/detail_back_home_btn.svg" alt="" />
    </div>

    <wx-open-launch-weapp
      :username="appid"
      :path="doctor_path"
      style="width:58px;height:58px;position: fixed;bottom: 80px;right: 10px;z-index: 999"
    >
      <script type="text/wxtag-template">
        <img width="100%" src="https://care-yyh.com/static/bytx/detail_expert_btn.svg" alt="">
      </script>
    </wx-open-launch-weapp>

    <div class="live-detail-footer">
      <!-- <div class="live-detail-column-box" v-if="live.parent != null">
        <van-cell
          title-class="control-title"
          is-link
          url="/course_list"
          :to="'/live-column/' + live.parent.id"
        >
          <div slot="title">
            <span class="live-detail-column-box-left">所属专题</span
            >{{ live.parent.title }}
          </div>
        </van-cell>
      </div> -->
      <div
        class="live-detail-footer-content-text"
        v-if="live && live.parent && live.parent.title"
        @click="goParent(live.parent)"
      >
        <van-image
          fit="cover"
          src="/static/bytx/detail_tag_column_icon.svg"
        ></van-image>
        <div>
          {{ live.parent.title }}
        </div>
        <div><van-icon name="arrow" /></div>
      </div>

      <div class="live-detail-footer-box">
        <div class="live-detail-footer-left">
          <van-grid :column-num="1" :border="false">
            <van-grid-item
              @click="favorite()"
              v-if="live.isFavorite"
              icon="/static/img/course/icon_course_favorite_on_20.svg"
              text="已收藏"
            />
            <van-grid-item
              @click="favorite()"
              v-else
              icon="/static/img/course/icon_course_favorite_off_20.svg"
              text="收藏"
            />
          </van-grid>
        </div>
        <div class="live-detail-footer-right">
          <van-button
            v-if="live.isAppointment == 0"
            type="danger"
            round
            size="large"
            @click="onClickButton"
            color="#0FB7AD"
          >
            {{ time > 0 ? "预约直播" : "进入直播间" }}
          </van-button>
          <div v-else class="live-detail-subscribe_notice">
            <div class="live-detail-subscribe_notice-left">
              <img src="/static/img/live/pic_live_reserve.svg" alt="" />
              <span>已预约</span>
            </div>
            <div class="live-detail-subscribe_notice-right" @click="goDetail">
              <img src="/static/img/live/pic_live_reserve_enter.svg" alt="" />
              <span>进入直播间</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      class="share"
      style="margin-top: 66px"
      v-model="showShareDialog"
      :showConfirmButton="false"
    >
      <img
        width="100%"
        class="share-top-img"
        src="/static/bytx/detail_share_title_img.png"
        alt=""
      />
      <div v-if="showShareLoading == false">
        <div class="share-img">
          <img
            :src="htmlUrl"
            style="width: 100%;border-radius: 10px;"
            v-if="htmlUrl != ''"
            alt=""
          />
        </div>
        <div class="share-cancel-btn" @click="showShareDialog = false">
          <img src="/static/img/course/icon_course_share_close.svg" alt="" />
        </div>
      </div>
      <div v-else align="center">
        <van-loading size="24px">正在生成转发图片</van-loading>
      </div>
    </van-dialog>

    <van-dialog
      class="content"
      v-model="needPassword"
      :show-confirm-button="false"
    >
      <template slot="title">
        本场直播需要您输入观看密码
      </template>
      <div class="cancel_otp_code_box">
        <div class="otpInputs">
          <input
            v-enterfocus
            ref="otpInputs"
            type="number"
            value="12"
            v-model="code"
            @keydown.delete="changeCode"
          />
          <span class="code_list">{{ code1 }}</span>
          <span class="code_list">{{ code2 }}</span>
          <span class="code_list">{{ code3 }}</span>
          <span class="code_list last_code_list">{{ code4 }}</span>
        </div>
        <p class="error_text" :class="{ show: error }">密码错误请重试</p>
      </div>
      <div class="content-footer">
        <van-button
          style="width: 50%"
          type="danger"
          round
          @click="checkPassword"
          color="#0FB7AD"
        >
          点击验证
        </van-button>
      </div>
    </van-dialog>
    <share-data :share-data="live" @getShareImg="getShareImg"></share-data>
  </div>
</template>

<script>
import Interface from "@/util/interface";
import columnSkeleton from "@/skeleton/columnSkeleton";
import verify from "../../../mixins/verify";
import checkLogin from "../../../mixins/checkLogin";
import shareData from "@/components/shareData/index";
import { toHomePage } from "@/util/common";
import wx from "weixin-js-sdk";

export default {
  name: "live-detail",
  mixins: [verify, checkLogin],
  components: {
    "column-skeleton": columnSkeleton,
    shareData
  },
  data() {
    return {
      appid: "gh_2af07dce0869",
      doctor_path:
        "pages/doctorModule/doctorList/index.html?routerName=expertList",

      live: {},
      value: "",
      active: "",
      loading: true,
      time: 0,
      share_data: {},
      showShareDialog: false,
      showShareLoading: false,
      htmlUrl: "",
      isShow: false,
      status: "",
      contentType: 0,
      pageType: 0
    };
  },
  methods: {
    fetch(scene) {
      if (scene === "live") {
        Interface.getData("get", Interface.live.detail + "/" + this.id).then(
          res => {
            this.live = res.data.live;
          localStorage.setItem("live_dialog_img", this.live.dialog_img);
            document.title = this.live.title;
            this.time = this.live.limit_time;
            Interface.mFootPrint(this.id, 93, 1, 1, 0, 0, 0, this.live.title);
            if (this.live) {
              this.setWechatShare();
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
          }
        );
      } else if (scene === "footprint") {
        // let params = {
        //     id: this.id,
        //     type: 4
        // }
        // Interface.getData('post', Interface.footprint, params).then(res => {})
      } else if (scene === "view_count") {
        let params = {
          id: this.id,
          type: 4,
          increment: 2
        };
        Interface.getData(
          "post",
          Interface.live.view_count,
          params
        ).then(res => {});
      }
    },
    favorite() {
      Interface.getData("get", Interface.live.favorite + this.id).then(res => {
        if (res.code == 0) {
          this.live.isFavorite = !this.live.isFavorite;
        }
      });
    },
    appointment() {
      if (this.live.need_auth == 1) {
        let user = localStorage.getItem("user");
        user = JSON.parse(user);
        if (user.new_reg_complete !== 1) {
          Interface.mFootPrint(this.id, 97, 1, 1, 0, 0, 0, this.live.title);
          sessionStorage.setItem("complete_from", "live");
          this.$dialog
            .confirm({
              title: "完善信息",
              message:
                "根据国家实名制要求，为了更好地为您提供健康管理服务，需您完善真实信息。\n",
              confirmButtonText: "确定",
              cancelButtonText: "取消"
            })
            .then(() => {
              Interface.mFootPrint(this.id, 94, 1, 1, 0, 0, 0, this.live.title);
              sessionStorage.setItem("back-url", this.$route.path);
              this.goAddInfo(user);
            })
            .catch(() => {
              if (user.is_complete === 1) {
                Interface.getData("get", Interface.user.reg_complete, {
                  new_reg_complete: 1
                });
                user.new_reg_complete = 1;
                localStorage.setItem("user", JSON.stringify(user));
              }
              // on cancel
            });
          if (user.new_reg_complete != 1) {
            return;
          }
        }
      }
      let url = this.pageType
        ? Interface.live.appointment + this.id + "?page_type=" + this.pageType
        : Interface.live.appointment + this.id;
      Interface.getData("get", url).then(res => {
        if (res.code == 0) {
          this.$toast.success("预约成功");
          this.fetch("live");
          if (this.live.need_password === 1 && !this.live.isPasswordAuth) {
            this.needPassword = true;
            return;
          }
          setTimeout(() => {
            this.goDetail();
          }, 1000);
        }
      });
    },
    onClickButton() {
      this.appointment();
    },
    goDetail() {
      if (this.live.need_password === 1 && !this.live.isPasswordAuth) {
        this.needPassword = true;
        return;
      }
      this.$router.push({ name: "live-detail-home", params: { id: this.id } });
    },
    toHome() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (localStorage.getItem("isMini") == 1) {
          wx.closeWindow(); // 关闭网页
          wx.miniProgram.reLaunch({ url: "/pages/home/index" });
        } else {
          window.location.href =
            "https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=bytx-home";
        }
      } else {
        toHomePage();
      }
    },
    goParent(row) {
      this.$router.push({ name: "live-column", params: { id: row.id } });
    },
    openShareData() {
      // let params = {
      //   content_id: this.id,
      //   type: 4
      // };
      // this.showShareLoading = true;
      // Interface.getData("get", Interface.share, params).then(res => {
      //   this.htmlUrl = res.data.post_img_url;
      //   this.showShareDialog = true;
      //   this.showShareLoading = false;
      // });
      this.showShareDialog = true;
    },
    getShareImg(url) {
      this.htmlUrl = url;
    },
    setWechatShare() {
      let desc = "点击观看直播";

      if (this.live.live_status == 6) {
        desc = "点击观看直播回放";
      }

      if (this.live.id > 230 && this.live.id < 235) {
        desc = "高博造血干细胞移植系列科普直播，快 “戳”进来观看~";
      }

      Interface.getShareInfo(this, this.live.title, this.live.cover_img, desc);
    },
    setCurrentUrl: () => {
      let url = location.href.replace(/&wx=[-]{}/g, "");
      window.history.replaceState({}, document.title, url);
    }
  },
  created() {
    this.setCurrentUrl();
    this.id = this.$route.params.id;
    this.pageType = this.$route.query.pageType;
    this.contentType = sessionStorage.getItem("contentType");
    this.fetch("live");
    this.fetch("footprint");
  }
};
</script>

<style lang="scss">
@import "./index.scss";
@import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/live/detail/index.vue